import React, { useEffect, useState } from 'react'
import { ContainerCard } from '../../reusable-components/AgiliteCards'
import { Col } from 'antd'

// Old components no longer needed - everything uses the new search engine
import SearchEngineWithProviders from '../../Search Engine'
import AgiliteSkeleton from '../../reusable-components/AgiliteSkeleton'
import { deviceDetect } from 'react-device-detect'
import CustomRow from '../../reusable-components/CustomRow'
import { useSelector } from 'react-redux'

const NewBooking = ({
  isHomeVisit,
  isReceptionBooking,
  isVirtualVisit,
  targetPatient,
  targetBooking,
  onAfterSuccess,
  onAfterFailed
}) => {
  const state = useSelector((state) => state)
  const [bookingDetails, setBookingDetails] = useState({
    dateCreated: null,
    service: null,
    medicalProfRef: null,
    userRef: null,
    endTime: null,
    province: isReceptionBooking
      ? state.clinics.data.find((clinic) => clinic._id === state.auth.agiliteUser.extraData.clinics[0]).province
      : null,
    bookingDate: null,
    // Preserve any additional properties like dischem data
    dischem: null
  })

  // Debug wrapper for setBookingDetails to track dischem data
  const wrappedSetBookingDetails = (newBookingDetails) => {
    console.log('🔍 AvailabilitySearchWrapper - setBookingDetails called')
    console.log('🔍 AvailabilitySearchWrapper - current bookingDetails:', bookingDetails)
    console.log('🔍 AvailabilitySearchWrapper - current bookingDetails.dischem:', bookingDetails.dischem)
    console.log('🔍 AvailabilitySearchWrapper - new bookingDetails:', newBookingDetails)
    console.log('🔍 AvailabilitySearchWrapper - new bookingDetails.dischem:', newBookingDetails.dischem)

    setBookingDetails(newBookingDetails)

    // Log after update (in next render cycle)
    setTimeout(() => {
      console.log('🔍 AvailabilitySearchWrapper - bookingDetails after update will be:', newBookingDetails)
    }, 0)
  }
  const [currentStep, setCurrentStep] = useState(0)
  const [steps, setSteps] = useState([])
  const [homeVisitState, setHomeVisitState] = useState(isHomeVisit || false)
  const [virtualVisitState, setVirtualVisitState] = useState(isVirtualVisit || false)
  const [patient, setPatient] = useState(targetPatient ? targetPatient : null)
  const [isNewPatient, setIsNewPatient] = useState(false)
  const [previousSearch, setPreviousSearch] = useState(null)
  const [mobileSteps, setMobileSteps] = useState(1)

  // Debug effect to track bookingDetails changes
  useEffect(() => {
    console.log('🔍 AvailabilitySearchWrapper - bookingDetails state changed:')
    console.log('🔍 AvailabilitySearchWrapper - bookingDetails:', bookingDetails)
    console.log('🔍 AvailabilitySearchWrapper - bookingDetails.dischem:', bookingDetails.dischem)
    console.log('🔍 AvailabilitySearchWrapper - All bookingDetails keys:', Object.keys(bookingDetails))
  }, [bookingDetails])

  useEffect(() => {
    generateSteps()
    // eslint-disable-next-line
  }, [isNewPatient, currentStep, patient, bookingDetails, homeVisitState, mobileSteps, virtualVisitState])

  const nextStep = () => {
    console.log('🔍 AvailabilitySearchWrapper - nextStep called, currentStep:', currentStep)
    setCurrentStep(currentStep + 1)
    window.scrollTo(0, 0)
  }

  // Function to transfer booking data to bookingDetails (for virtual consultations)
  const transferBookingToBookingDetails = (bookingData) => {
    console.log('🔍 AvailabilitySearchWrapper - transferBookingToBookingDetails called')
    console.log('🔍 AvailabilitySearchWrapper - Received booking data:', bookingData)
    console.log('🔍 AvailabilitySearchWrapper - Booking data dischem:', bookingData.dischem)

    // Update bookingDetails with the booking data
    wrappedSetBookingDetails(bookingData)
  }

  const prevStep = () => {
    setCurrentStep(currentStep - 1)
    window.scrollTo(0, 0)
  }

  const generateSteps = () => {
    let tmpSteps = []

    if (isHomeVisit) {
      // Use the new search engine for home visits as well
      tmpSteps = [
        {
          title: 'Home Visit',
          content: <SearchEngineWithProviders isVirtualVisit={false} isHomeVisit={true} />
        }
      ]
    } else if (isVirtualVisit) {
      // Use the new search engine for virtual visits
      tmpSteps = [
        {
          title: 'Virtual Consultation',
          content: <SearchEngineWithProviders isVirtualVisit={isVirtualVisit} />
        }
      ]
    } else {
      // Use the new search engine for regular clinic bookings
      tmpSteps = [
        {
          title: 'Find a Doctor',
          content: <SearchEngineWithProviders isVirtualVisit={false} />
        }
      ]
    }

    setSteps(tmpSteps)
  }

  const checkRelevantStep = () => {
    if (isVirtualVisit) {
      return currentStep === 3
    }
    if (isReceptionBooking) {
      return currentStep === 3
    }
    if (isHomeVisit) {
      return currentStep === 3
    }

    return currentStep === 2
  }

  return (
    <ContainerCard
      backFunction={
        currentStep === 0 || deviceDetect().isMobile ? undefined : checkRelevantStep() ? undefined : prevStep
      }
      title={homeVisitState ? 'New Home Visit' : isVirtualVisit ? 'New Virtual Consultation' : 'New Clinic Booking'}
    >
      <CustomRow>
        <Col span={24}>{steps && steps.length > 0 ? <>{steps[currentStep].content}</> : <AgiliteSkeleton />}</Col>
      </CustomRow>
    </ContainerCard>
  )
}

export default NewBooking
